import React, { FC, useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { IApiCompany } from 'src/models/company/types';
import { useTranslation } from 'react-i18next';
import { confirm, notification, Select } from 'src/common';
import modalStyles from 'src/common/Modal/index.module.scss';
import { UPDATE_COMPANY_INFO } from 'src/models/company/queries';
import { Country } from '@tendium/prom-types';

interface PricePlanSelectProps {
  companyId: string;
  country: Country;
}

export const SalesOfficeSelect: FC<PricePlanSelectProps> = props => {
  const { country, companyId } = props;
  const { t } = useTranslation();
  const [currentCountry, setCurrentCountry] = useState(country);
  const avialableSalesOffice = Object.keys(Country);

  const [updateCompanyInfo] = useMutation<{ updateCompany: IApiCompany }, { id: string; country: Country }>(
    UPDATE_COMPANY_INFO
  );

  const selectCountry = useCallback(
    selectedCountry => {
      confirm.confirm({
        title: t('AdminPage.confirmTitle'),
        okText: t('Common.yes'),
        cancelText: t('Common.no'),
        className: modalStyles.confirmModal,
        centered: true,
        onOk() {
          updateCompanyInfo({ variables: { id: companyId, country: selectedCountry } })
            .then(response => {
              if (response.data?.updateCompany) setCurrentCountry(response.data?.updateCompany.country);
            })
            .catch(() => {
              notification.error({
                message: t('Common.unknownError'),
                description: t('Common.unknownErrorDesc')
              });
            });
        }
      });
    },
    [companyId, t, updateCompanyInfo]
  );

  return (
    <Select
      style={{ width: '100%' }}
      value={currentCountry}
      onSelect={selectCountry}
      size={'small'}
      dropdownRender={menu => <>{menu}</>}
    >
      {avialableSalesOffice.map(val => (
        <Select.Option value={val} key={val}>
          {t(`SalesOffice.${val}`)}
        </Select.Option>
      ))}
    </Select>
  );
};
